// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as LoadingDExtended } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/extended/loading-d.svg?react';
import { createIcons } from '../../Icon';
export const LoadingDIcon = /* @__PURE__ */ createIcons('LoadingD', {
    extended: LoadingDExtended
});
LoadingDIcon.supportedTypes = [
    'extended'
];
